// extracted by mini-css-extract-plugin
export default {"card":"game-card_card__g+pya","card-title":"game-card_card-title__vPNMP","card-text":"game-card_card-text__6oAu-","card-date":"game-card_card-date__f9rGH"};